import { useStrings } from '../i18n/context';

interface Props {
  readonly unexpected: boolean;
  readonly onRejoin: () => void;
  readonly onNewMeeting: () => void;
}

export function LeftScreen({ unexpected, onRejoin, onNewMeeting }: Props) {
  const strings = useStrings();
  return (
    <main className="left" aria-labelledby="vm-left-heading">
      <div className="lobby__card">
        <h1 id="vm-left-heading">{strings.leftHeading}</h1>
        {unexpected && <p role="alert">{strings.leftUnexpected}</p>}
        <div className="left__actions">
          <button type="button" className="button button--primary" onClick={onRejoin}>
            {strings.rejoin}
          </button>
          <button type="button" className="button" onClick={onNewMeeting}>
            {strings.newMeeting}
          </button>
        </div>
      </div>
    </main>
  );
}
